import { getAdminProjects } from '@lib/api'
import { adminProjectsKeys } from '@lib/keys'
import { useQuery } from '@tanstack/react-query'

export const useAdminProjects = () => {
  return useQuery(adminProjectsKeys.all, () => getAdminProjects())
}
